import React from 'react'

export default function RegisterCustomerAccountFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .form-container {
          font-size: 1.2rem;
          display: flex;
          flex-direction: column;
        }

        .label-input-container {
          display: flex;
          padding: 5px;
        }

        .label-input-container label {
          flex: 3;
          padding: 3px;
        }

        .label-input-container input {
          flex: 5;
          padding: 3px;
        }

        .form-action-buttons-container {
          display: flex;
          margin-top: 10px;
          justify-content: flex-end;
        }

      `}
      </style>
    </React.Fragment>
  )
}
